import { withStyle } from 'baseui';
import { StyledLink } from 'baseui/link';
const Link = withStyle<typeof StyledLink, {}>(StyledLink, ({
  $theme
}) => ({
  color: $theme.colors.accent,
  wordBreak: 'break-all',
  ':visited': {
    color: $theme.colors.accent
  }
}));
export default Link;